import { createSession, getSession, sendTurn } from '../../api';

// 活跃对话会话（模块②标准化病人 / ⑤问诊训练共用）
// state: sessionId/messages/typing/title/covered/coverage/demo
export default {
  namespaced: true,
  state: () => ({
    sessionId: null,
    module: null,
    title: '',
    messages: [],
    covered: [],
    coverage: 0,
    typing: false,
    demo: false,
    lastFeedback: '',
  }),
  mutations: {
    reset(s, module) {
      s.sessionId = null; s.module = module; s.title = ''; s.messages = [];
      s.covered = []; s.coverage = 0; s.typing = false; s.demo = false; s.lastFeedback = '';
    },
    setSession(s, { id, title, demo }) {
      s.sessionId = id; s.title = title; s.demo = !!demo;
    },
    pushMessage(s, msg) { s.messages.push(msg); },
    setTyping(s, v) { s.typing = v; },
    updateCoverage(s, { covered, coverage, feedback }) {
      if (covered) s.covered = covered;
      if (coverage != null) s.coverage = coverage;
      if (feedback != null) s.lastFeedback = feedback;
    },
    restore(s, { title, messages, meta, demo }) {
      s.title = title; s.demo = !!demo;
      s.messages = (messages || []).map((m) => ({ role: m.role === 'ai' ? 'ai' : 'user', content: m.content, meta: m.meta }));
      s.covered = (meta && meta.covered) || [];
      s.coverage = (meta && meta.coverage) || 0;
    },
  },
  actions: {
    // 开新会话；patient 模式首轮由后端剧本自然开场（AI 等学生先说）
    async start({ commit, state }, { module, title }) {
      commit('reset', module);
      const s = await createSession(module, title);
      commit('setSession', { id: s.id, title: s.title, demo: s.demo });
      return s;
    },
    async load({ commit, state }, id) {
      const s = await getSession(id);
      commit('setSession', { id: s.id, title: s.title, demo: s.demo });
      commit('restore', s);
      return s;
    },
    async send({ commit, state }, utterance) {
      if (!state.sessionId || state.typing) return null;
      commit('pushMessage', { role: 'user', content: utterance });
      commit('setTyping', true);
      try {
        const res = await sendTurn(state.sessionId, utterance);
        commit('pushMessage', {
          role: 'ai', content: res.reply,
          meta: res.coveredDimensions ? { coveredDimensions: res.coveredDimensions, coverage: res.coverage } : null,
        });
        commit('updateCoverage', res);
        if (res.demo) commit('setSession', { id: state.sessionId, title: state.title, demo: true });
        return res;
      } finally {
        commit('setTyping', false);
      }
    },
  },
};
